// ENV
export const baseDomain = process.env.REACT_APP_BASE_DOMAIN;
export const baseUrl = process.env.REACT_APP_BASE_URL;
export const imgServerBaseUrl = process.env.REACT_APP_IMG_SERVER;
export const siteKey = process.env.REACT_APP_SITE_KEY; // reCAPTCHA

// USER
export const getUserRoute = "/users/show";
export const refreshRoute = "/refresh-token/";
export const signInRoute = "/login/sanctum";
export const signUpRoute = "/register-tournament-admin/";
export const forgotPasswordRoute = "/password-reset/";
export const logoutRoute = "/logout/sanctum";
export const facebookLoginRoute = "/login/facebook/";
export const userAccountsRoute = "/users/user-accounts";
export const userEstablishmentsRoute = "/users/managed-establishments";
export const userManagedEstablishmentsRoute = "competitions/establishments/managed";

// TOURNAMENTS
export const tournamentsIndexRoute = "/tournaments";
export const tournamentsShowRoute = (uuid) => `/tournaments/${uuid}`;
export const tournamentsCreateRoute = "/tournaments/create";
export const tournamentsStartRoute = "/tournaments/start";
export const tournamentsUpdateRoute = "/tournaments/update";
export const endGroupStageRoute = "/tournaments/end-group-stage";
export const restartTournamentRoute = "/tournaments/restart";
export const deleteTournamentRoute = "/tournaments/destroy";
export const updateRoundRoute = "/tournaments/update-round";
export const tournamentsFinishRoute = "/tournaments/finish";
export const tournamentsPublishRoute = "/tournaments/publish";
export const tournamentGetSpacesRoute = "/tournaments/spaces";
export const tournamentGetSignUpsRoute = "/tournaments/sign-ups";
export const tournamentGetParticipantsRoute = "/tournaments/participants";
export const tournamentGetPlayersStandingsRoute = "/tournaments/players-standings";
export const tournamentGetGroupStageRankingRoute = "/tournaments/group-stage-rankings";
export const tournamentGetFinalRankingsRoute = "/tournaments/final-rankings";
export const tournamentsIndexAllRoute = "tournaments/index-all";

// ORGANIZATIONS
export const getOrganizationRoute = "/organizations/show";
export const postOrganizationEditRoute = "/organizations/update";
export const organizationShowBySlugRoute = "/organizations/by-slug";
export const getUserOrganizationsRoute = "/organizations/user-organizations";
export const getOrganizationUnlinkedParticipantsRoute = "/organizations/unlinked-participants";
export const exportOrganizationRankingsStandignsRoute = "/classifications/organization/export-rankings";

// ORGANIZATION MEMBERS
export const getOrganizationMembersRoute = "/organizations/members";
export const getOrganizationMemberRoute = "/organizations/members/show";
export const organizationMembersImportRoute = "organizations/members/import";
export const organizationMembersExportRoute = "organizations/members/export";
export const updateOrganizationMemberRoute = (id) => `/organizations/members/${id}`;
export const getOrganizationMemberAdminRoute = (organizationId, memberId) => `/organizations/${organizationId}/members/${memberId}`;
export const getAssignableOfficialCategoriesRoute = (organizationId) => `/organizations/${organizationId}/assignable-official-categories`;
export const getMemberCategoryAssignmentsRoute = (organizationId, memberId) => `/organizations/${organizationId}/members/${memberId}/category-assignments`;
export const createMemberCategoryAssignmentRoute = (organizationId, memberId) => `/organizations/${organizationId}/members/${memberId}/category-assignments`;
export const getOfficialCategoryDiagnosticsRoute = (organizationId) => `/organizations/${organizationId}/official-category-enforcement-diagnostics`;
export const deleteOrganizationMemberRoute = (id) => `/organizations/members/${id}`;
export const createOrganizationMemberRoute = "/organizations/members";
export const getMembersByIdentifiersRoute = "/organizations/members/search-by-identifiers";
export const postAssignUserToMemberRoute = "/organizations/members/assign-user";
export const postCreateAndAssignUserToMemberRoute = "/organizations/members/create-and-assign-user";
export const postAssignMemberToPlayerRoute = "/organizations/members/assign-to-player";
export const postCreateAndAssignMemberToPlayerRoute = "/organizations/members/create-and-assign-to-player";
export const searchOrganizationMemberUserRoute = (organizationId, memberId) =>
  `/organizations/${organizationId}/members/${memberId}/user-link/search`;
export const organizationMemberUserLinkRoute = (organizationId, memberId) =>
  `/organizations/${organizationId}/members/${memberId}/user-link`;
export const organizationMemberDeletionImpactRoute = (organizationId, memberId) =>
  `/organizations/${organizationId}/members/${memberId}/deletion-impact`;
export const mergeOrganizationMemberRoute = (organizationId, memberId) =>
  `/organizations/${organizationId}/members/${memberId}/merge`;

// ORGANIZATION MANUAL CLASSIFICATION POINTS
export const getManualPointsRoute = (organizationId, classificationId) =>
  `/organizations/${organizationId}/classifications/${classificationId}/manual-points`;
export const postManualPointsRoute = (organizationId, classificationId) =>
  getManualPointsRoute(organizationId, classificationId);
export const putManualPointsRoute = (organizationId, classificationId) =>
  getManualPointsRoute(organizationId, classificationId);
export const deleteManualPointsRoute = (organizationId, classificationId, pointId) =>
  `/organizations/${organizationId}/classifications/${classificationId}/manual-points/${pointId}`;

// CLASSIFICATIONS PUBLIC
export const classificationsPublicIndexRoute = "/tournaments/classifications-public";
export const getClassificationRoute = "tournaments/classifications-public/show";
export const getRankingImage = "tournaments/classifications-public/ranking-image";
export const getManualAscentClassificationRoute = "tournaments/classifications/manual/ascent";
export const getManualDescentClassificationRoute = "tournaments/classifications/manual/descent";

//CLASSIFICATIONS RESTRICTED
export const classificationsIndexRoute = "/tournaments/classifications";
export const classificationShowRoute = "/tournaments/classifications/show";
export const classificationRecalculateSeasonRoute = "/tournaments/classifications/recalculate-season";
export const classificationOpenCurrentSeasonRoute = "/tournaments/classifications/open-current-season";
export const classificationCreateRoute = "/tournaments/classifications/create";
export const classificationUpdateRoute = "/tournaments/classifications/update";
export const assignTournamentToClassificationRoute = "tournaments/classifications/assign-tournament";
export const updateClassificationTournamentsRoute = "/tournaments/classifications/update-tournaments";
export const classificationEventSystemsIndexRoute = "/tournaments/classifications/events-systems";
export const classificationEventSystemShowRoute = "/tournaments/classifications/events-systems/show";
export const classificationEventSystemCreateRoute = "/tournaments/classifications/events-systems/create";
export const classificationEventSystemUpdateRoute = "/tournaments/classifications/events-systems/update";
export const classificationToogleArchivedRoute = "/tournaments/classifications/toggle-archived";

// PUNCTUATION
export const punctuationIndexRoute = "/tournaments/punctuation-systems";
export const punctuationCreateRoute = "/tournaments/punctuation-systems/create";
export const punctuationUpdateRoute = "/tournaments/punctuation-systems/update";
export const punctuationShowRoute = "/tournaments/punctuation-systems/show";

// PARTICIPANTS
export const participantsIndexRoute = "/participants";
export const participantsShowRoute = "/participants/show";
export const participantsCreateRoute = "/participants/create";
export const participantsUpdateRoute = "/participants/update";
export const tournamentEligibleMembersRoute = (tournamentId) => `/tournaments/${tournamentId}/eligible-members`;
export const participantsDeleteRoute = "/participants/destroy";
export const participantsExchangeRoute = "/participants/exchange-positions";
export const participantsReorderRoute = "/participants/reorder";
export const participantsMarkAsPaidRoute = "/participants/mark-as-paid";
export const participantsMoveToTournament = "/participants/move-to-tournament";
export const sportCountriesPublicRoute = "/public/sport-countries";
export const competitionBoardPublicRoute = (uuid) => `/public/competitions/${uuid}/board`;
export const participantsAddSeedPlayerRoute = "/participants/add-seed-player";
export const participantsRestoreWithdrawnRoute = "/participants/restore-withdrawn";
export const participantsAssignOrganizationMemberRoute = "/participants/assign-organization-member";
export const participantsConvertOrganizationMemberToManualRoute =
  "/participants/convert-organization-member-to-manual";

//USER PROFILES
export const userProfileGet = "/users/public-tournaments-profile";

// MATCHES
export const matchesShowRoute = "/matches/show";
export const matchesUpdateRoute = "/matches/update";
export const matchesReopenRoute = "/matches/reopen";
export const matchesUpdateScoreDetailsRoute = "/matches/update-score-details";

// CATEGORIES
export const categoriesCreateRoute = "/categories/create";
export const categoriesUpdateRoute = "/categories/update";
export const categoriesDeleteRoute = "/categories/destroy";
export const categoriesForTournamentsRoute = "/categories/for-tournaments";
export const officialCategoriesForSport = "/categories/official-categories-for-sport";

// VIDEOGAMES
export const searchGamesRoute = "/videogames/search";

// PLAYERS
export const searchUserRoute = "/players/search-user";
export const assignUserRoute = "/players/assign-user";
export const playerUpdateRoute = "/players/update";
export const tournamentClaimGenerateRoute = "/tournaments/claim/generate";

// COMPETITIONS
export const competitionsIndexRoute = "/competitions";
export const competitionsShowRoute = "/competitions/show";
export const competitionsPublicRoute = "/event/show";
export const competitionsCreateRoute = "/competitions/create";
export const competitionsStartRoute = "/competitions/start";
export const competitionsUpdateRoute = "/competitions/update";
export const competitionsTournamentsRoute = "/competitions/tournaments";
export const competitionsGetSignUpsRoute = "/competitions/sign-ups";
export const competitionsNavigationSummaryRoute = "/competitions/navigation-summary";
export const competitionMatchScoringRoute = "/competitions/match-scoring";
export const competitionMatchScoringUpdateRoute = "/competitions/match-scoring/update";
export const tournamentMatchScoringRoute = "/tournaments/match-scoring";
export const tournamentMatchScoringUpdateRoute = "/tournaments/match-scoring/update";
export const tournamentMatchScoringPresetsRoute = "/tournaments/match-scoring/presets";
export const competitionsRegistrationsRoute = "/competitions/registrations";
export const competitionsRegistrationsExportRoute = "/competitions/registrations/export";
export const competitionsDashboardRoute = "/competitions/dashboard";
export const competitionsToggleArchivedRoute = "/competitions/toggle-archived";
export const competitionsTogglePublishedRoute = "/competitions/toggle-published";
export const competitionsToggleBoardRoute = "/competitions/toggle-board";
export const competitionsGenerateDynamicLinkRoute = "/competitions/generate-dynamic-link";
export const competitionsReorderTournamentsRoute = "/competitions/reorder-tournaments";
export const competitionsCalendarEventsRoute = "/competitions/calendar-events";
export const getCompetitionsFixtureRoute = (uuid) => `competitions/${uuid}/schedule`;
export const competitionsExportScheduleRoute = (uuid) => `competitions/${uuid}/schedule/export`;

export const competitionsUsersRoute = "/competitions/users";
export const competitionsUsersInviteRoute = "/competitions/users/invite";
export const competitionUsersCancelInviteRoute = "/competitions/users/cancel-invite";
export const competitionUsersDeleteRoute = "/competitions/users/delete";

export const competitionEstablishmentsAddRoute = "/competitions/establishments/add";
export const competitionEstablishmentsDeleteRoute = "/competitions/establishments/delete";
export const competitionTournamentVenuesRoute = "/competitions/tournament-venues";
export const competitionTournamentVenueRoute = (venueId) => `/competitions/tournament-venues/${venueId}`;

export const competitionParticipantsExportRoute = (id) => `competitions/${id}/participants/export`;

// COMPETITION CUSTOM FIELDS
export const competitionCustomFieldsIndexRoute = "/competitions/custom-fields/index";
export const competitionCustomFieldsStoreRoute = "/competitions/custom-fields/store";
export const competitionCustomFieldsUpdateRoute = "/competitions/custom-fields/update";
export const competitionCustomFieldsDestroyRoute = "/competitions/custom-fields/destroy";
export const competitionCustomFieldsReorderRoute = "/competitions/custom-fields/reorder";
export const competitionCustomFieldsCopyFromRoute = "/competitions/custom-fields/copy-from";

// SCHEDULING
export const schedulingConfigRoute = "/scheduling/config";
export const schedulingPreparationUpdateRoute = "/scheduling/preparation/update";
export const schedulingSaveConfigRoute = "/scheduling/config/save";
export const schedulingWindowsSaveRoute = "/scheduling/windows/save";
export const schedulingWindowsDeleteRoute = "/scheduling/windows/delete";
export const schedulingSlotsRoute = "/scheduling/slots";
export const schedulingPreviewRoute = "/scheduling/preview";
export const schedulingRunRoute = "/scheduling/run";
export const schedulingClearRoute = "/scheduling/clear";

// TOURNAMENT SIGN UPS
export const tournamentSignUpsShowRoute = "tournament-sign-ups/show";

//STATS
export const tournamentsCategoriesStats = "/tournaments/category-stats";

//LIVESTREAM
export const liveStreamVSBanner = "/live-match/vs-banner";

//CUSTOMERS
export const customersIndexRoute = "/customers/index";

//SUBSCRIPTIONS
export const subscriptionsIndexRoute = "/subscriptions/getProductPlans";
export const subscribeToCompetitionServiceRoute = "/subscriptions/subscribeToCompetitionService";

// LEAGUE (Fansbury migration — native admin API, Sanctum cookie)
const league = (path) => `/league${path}`;
export const leagueAccessibleCustomersRoute = league("/accessible-customers");
export const leagueCustomerFeaturesRoute = (customerId) => league(`/customers/${customerId}/features`);
export const leagueCustomerSettingsRoute = (customerId) => league(`/customers/${customerId}/settings`);
export const leagueCustomerMatchSheetPreviewRoute = (customerId) =>
  league(`/customers/${customerId}/settings/match-sheet/preview`);
export const leagueCustomerSettingsImagesRoute = (customerId) => league(`/customers/${customerId}/settings/images`);
export const leagueCustomerPushBroadcastsRoute = (customerId) => league(`/customers/${customerId}/push/broadcasts`);
export const leagueCustomerAdministratorsRoute = (customerId) => league(`/customers/${customerId}/administrators`);
export const leagueCustomerAdministratorRoute = (customerId, userId) =>
  league(`/customers/${customerId}/administrators/${userId}`);
export const leagueCustomerAdministratorInviteRoute = (customerId, inviteId) =>
  league(`/customers/${customerId}/administrators/invites/${inviteId}`);
export const leagueCustomerRosterMemberUserSearchRoute = (customerId, memberId) =>
  league(`/customers/${customerId}/roster/members/${memberId}/user-search`);
export const leagueCustomerRosterRoute = (customerId) => league(`/customers/${customerId}/roster`);
export const leagueCustomerRosterMembersRoute = (customerId) => league(`/customers/${customerId}/roster/members`);
export const leagueCustomerRosterMemberRoute = (customerId, memberId) =>
  league(`/customers/${customerId}/roster/members/${memberId}`);
export const leagueCustomerRosterMemberMediaRoute = (customerId, memberId) =>
  league(`/customers/${customerId}/roster/members/${memberId}/media`);
export const leagueCustomerRosterMemberMedicalRecordsRoute = (customerId, memberId) =>
  league(`/customers/${customerId}/roster/members/${memberId}/medical-records`);
export const leagueCustomerRosterMemberMedicalRecordRoute = (customerId, memberId) =>
  league(`/customers/${customerId}/roster/members/${memberId}/medical-record`);
export const leagueCustomerRosterMembersCsvRoute = (customerId) => league(`/customers/${customerId}/roster/members/csv`);
export const leagueCustomerRosterCustomFieldsRoute = (customerId) => league(`/customers/${customerId}/roster/custom-fields`);
export const leagueCustomerTeamsRoute = (customerId) => league(`/customers/${customerId}/teams`);
export const leagueCustomerTeamsCsvRoute = (customerId) => league(`/customers/${customerId}/teams/csv`);
export const leagueCustomerTeamRoute = (customerId, teamId) => league(`/customers/${customerId}/teams/${teamId}`);
export const leagueCustomerTeamPlayersRoute = (customerId, teamId) =>
  league(`/customers/${customerId}/teams/${teamId}/players`);
export const leagueCustomerTeamPlayerRoute = (customerId, teamId, playerId) =>
  league(`/customers/${customerId}/teams/${teamId}/players/${playerId}`);
export const leagueCustomerTeamImagesRoute = (customerId, teamId) => league(`/customers/${customerId}/teams/${teamId}/images`);
export const leagueCustomerLineupsPlayersCsvRoute = (customerId) => league(`/customers/${customerId}/lineups/players/csv`);
export const leagueCustomerRefereesRoute = (customerId) => league(`/customers/${customerId}/referees`);
export const leagueCustomerRefereeRoute = (customerId, refereeId) => league(`/customers/${customerId}/referees/${refereeId}`);
export const leagueCustomerVenuesRoute = (customerId) => league(`/customers/${customerId}/venues`);
export const leagueCustomerVenueRoute = (customerId, venueId) => league(`/customers/${customerId}/venues/${venueId}`);
export const leagueCustomerVenueFieldsRoute = (customerId, venueId) =>
  league(`/customers/${customerId}/venues/${venueId}/fields`);
export const leagueCustomerVenueFieldRoute = (customerId, venueId, fieldId) =>
  league(`/customers/${customerId}/venues/${venueId}/fields/${fieldId}`);
export const leagueTournamentVenuesRoute = () => league(`/tournament-venues`);
export const leagueCustomerFinancialChargeTemplatesRoute = (customerId) =>
  league(`/customers/${customerId}/financial/charge-templates`);
export const leagueCustomerFinancialChargeTemplateRoute = (customerId, templateId) =>
  league(`/customers/${customerId}/financial/charge-templates/${templateId}`);
export const leagueCustomerFinancialEntryFeeOptionsRoute = (customerId) =>
  league(`/customers/${customerId}/financial/entry-fee-options`);
export const leagueCustomerFinancialDebtSummaryRoute = (customerId) =>
  league(`/customers/${customerId}/financial/debt-summary`);
export const leagueCustomerFinancialIncomeSummaryRoute = (customerId) =>
  league(`/customers/${customerId}/financial/income-summary`);
export const leagueCustomerFinancialSiloBalancesRoute = (customerId) =>
  league(`/customers/${customerId}/financial/silo-balances`);
export const leagueCustomerFinancialTransactionsSummaryRoute = (customerId) =>
  league(`/customers/${customerId}/financial/transactions-summary`);
export const leagueCustomerFinancialAccountsRoute = (customerId) =>
  league(`/customers/${customerId}/financial/accounts`);
export const leagueCustomerFinancialEntitiesRoute = (customerId) =>
  league(`/customers/${customerId}/financial/entities`);
export const leagueCustomerFinancialEntityRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}`);
export const leagueCustomerFinancialEntityBalanceRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/balance`);
export const leagueCustomerFinancialEntityInvoicesRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/invoices`);
export const leagueCustomerFinancialEntityDebtsRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/debts`);
export const leagueCustomerFinancialEntityApplyChargeRoute = (customerId, externalEntityId, templateId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/apply-charge/${templateId}`);
export const leagueCustomerFinancialEntityRegisterInvoicesPaymentRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/register-invoices-payment`);
export const leagueCustomerFinancialEntityPaymentLinksRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/payment-links`);
export const leagueCustomerFinancialEntityRegisterAddBalanceRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/register-add-balance`);
export const leagueCustomerFinancialEntityIndividualsRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals`);
export const leagueCustomerFinancialEntityIndividualBalanceRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/balance`);
export const leagueCustomerFinancialEntityIndividualInvoicesRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/invoices`);
export const leagueCustomerFinancialEntityIndividualDebtsRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/debts`);
export const leagueCustomerFinancialEntityIndividualApplyChargeRoute = (customerId, externalEntityId, externalIndividualId, templateId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/apply-charge/${templateId}`);
export const leagueCustomerFinancialEntityIndividualRegisterInvoicesPaymentRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/register-invoices-payment`);
export const leagueCustomerFinancialEntityIndividualPaymentLinksRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/payment-links`);
export const leagueCustomerFinancialEntityIndividualRegisterAddBalanceRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/register-add-balance`);
export const leagueCustomerFinancialLegalInvoiceRoute = (customerId, paymentId) =>
  league(`/customers/${customerId}/financial/payments/${paymentId}/legal-invoice`);
export const leagueCustomerFinancialPaymentVoidCreditRoute = (customerId, paymentId) =>
  league(`/customers/${customerId}/financial/payments/${paymentId}/void-credit`);
export const leagueCustomerFinancialPaymentVoidLinkRoute = (customerId, paymentId) =>
  league(`/customers/${customerId}/financial/payments/${paymentId}/void-link`);
export const leagueCustomerFinancialPaymentRoute = (customerId, paymentId) =>
  league(`/customers/${customerId}/financial/payments/${paymentId}`);
export const leagueCustomerFinancialEntityVoidInvoicesRoute = (customerId, externalEntityId) =>
  league(`/customers/${customerId}/financial/entities/${externalEntityId}/invoices/void`);
export const leagueCustomerFinancialEntityIndividualVoidInvoicesRoute = (customerId, externalEntityId, externalIndividualId) =>
  league(
    `/customers/${customerId}/financial/entities/${externalEntityId}/individuals/${externalIndividualId}/invoices/void`,
  );
export const leagueCustomerMatchesRoute = (customerId) => league(`/customers/${customerId}/matches`);
export const leagueCustomerDashboardRoute = (customerId) => league(`/customers/${customerId}/dashboard`);
export const leagueCustomerMembershipSettingsRoute = (customerId) => league(`/customers/${customerId}/membership-settings`);
export const leagueCustomerMembershipsEnrollMissingRoute = (customerId) =>
  league(`/customers/${customerId}/memberships/enroll-missing`);
export const leagueCustomerMembershipsEnrollMissingContinueRoute = (customerId, runId) =>
  league(`/customers/${customerId}/memberships/enroll-missing/${runId}/continue`);
export const leagueCustomerMigrationPlayersTemplateRoute = (customerId) =>
  league(`/customers/${customerId}/migration/players/template`);
export const leagueCustomerMigrationTeamsTemplateRoute = (customerId) =>
  league(`/customers/${customerId}/migration/teams/template`);
export const leagueCustomerMigrationPlayersPreviewRoute = (customerId) =>
  league(`/customers/${customerId}/migration/players/preview`);
export const leagueCustomerMigrationTeamsPreviewRoute = (customerId) =>
  league(`/customers/${customerId}/migration/teams/preview`);
export const leagueCustomerMigrationExecuteRoute = (customerId) =>
  league(`/customers/${customerId}/migration/execute`);
export const leagueCustomerMigrationStatusRoute = (customerId) => league(`/customers/${customerId}/migration/status`);
export const leagueCustomerFansburyMigrationStatusRoute = (customerId) =>
  league(`/customers/${customerId}/fansbury-migration/status`);
export const leagueCustomerFansburyMigrationPreviewRoute = (customerId) =>
  league(`/customers/${customerId}/fansbury-migration/preview`);
export const leagueCustomerFansburyMigrationStartRoute = (customerId) =>
  league(`/customers/${customerId}/fansbury-migration/start`);
export const leagueCustomerFansburyMigrationRemigrateRoute = (customerId) =>
  league(`/customers/${customerId}/fansbury-migration/remigrate`);
export const leagueCustomerMembershipsRoute = (customerId) => league(`/customers/${customerId}/memberships`);
export const leagueCustomerMembershipRoute = (customerId, membershipId) =>
  league(`/customers/${customerId}/memberships/${membershipId}`);
export const leagueCustomerMembershipPayRoute = (customerId, membershipId) =>
  league(`/customers/${customerId}/memberships/${membershipId}/pay`);
export const leagueCustomerMembershipPaymentLinksRoute = (customerId, membershipId) =>
  league(`/customers/${customerId}/memberships/${membershipId}/payment-links`);
export const leagueCustomerMembershipStatusRoute = (customerId, membershipId) =>
  league(`/customers/${customerId}/memberships/${membershipId}/status`);
export const leagueCustomerMembershipLifetimeRoute = (customerId, membershipId) =>
  league(`/customers/${customerId}/memberships/${membershipId}/lifetime`);
export const organizationMembershipSettingsRoute = (organizationId) => `/organizations/${organizationId}/membership-settings`;
export const organizationMembershipOverviewRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-overview`;
export const organizationMembershipPaymentsRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-payments`;
export const organizationMembershipImportTemplateRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-import/template`;
export const organizationMembershipImportExportRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-import/export`;
export const organizationMembershipImportPreviewRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-import/preview`;
export const organizationMembershipImportCommitRoute = (organizationId) =>
  `/organizations/${organizationId}/membership-import/commit`;
export const organizationMembershipsRoute = (organizationId) => `/organizations/${organizationId}/memberships`;
export const organizationMembershipRoute = (organizationId, membershipId) =>
  `/organizations/${organizationId}/memberships/${membershipId}`;
export const organizationMembershipPayRoute = (organizationId, membershipId) =>
  `/organizations/${organizationId}/memberships/${membershipId}/pay`;
export const organizationMembershipVoidInstallmentsRoute = (organizationId, membershipId) =>
  `/organizations/${organizationId}/memberships/${membershipId}/void-installments`;
export const organizationMembershipEnrollMissingRoute = (organizationId) =>
  `/organizations/${organizationId}/memberships/enroll-missing`;
export const organizationMembershipStatusRoute = (organizationId, membershipId) =>
  `/organizations/${organizationId}/memberships/${membershipId}/status`;
export const leagueCustomerTournamentsRoute = (customerId) => league(`/customers/${customerId}/tournaments`);
export const leagueTournamentRoute = (tournamentId) => league(`/tournaments/${tournamentId}`);
export const leagueTournamentConfigRoute = (tournamentId) => league(`/tournaments/${tournamentId}/config`);
export const leagueTournamentGroupsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/groups`);
export const leagueTournamentGroupRoute = (tournamentId, groupId) => league(`/tournaments/${tournamentId}/groups/${groupId}`);
export const leagueTournamentMatchdaysRoute = (tournamentId) => league(`/tournaments/${tournamentId}/matchdays`);
export const leagueTournamentMatchdayRoute = (tournamentId, matchdayId) => league(`/tournaments/${tournamentId}/matchdays/${matchdayId}`);
export const leagueTournamentMatchdayDisplaceRoute = (tournamentId, matchdayId) =>
  league(`/tournaments/${tournamentId}/matchdays/${matchdayId}/displace`);
export const leagueTournamentLineupsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/lineups`);
export const leagueTournamentLineupsRegisterTeamRoute = (tournamentId) =>
  league(`/tournaments/${tournamentId}/lineups/register-team`);
export const leagueTournamentLineupRoute = (tournamentId, lineupId) =>
  league(`/tournaments/${tournamentId}/lineups/${lineupId}`);
export const leagueTournamentLineupsPlayersCsvRoute = (tournamentId) => league(`/tournaments/${tournamentId}/lineups/players/csv`);
export const leagueTournamentMatchesRoute = (tournamentId) => league(`/tournaments/${tournamentId}/matches`);
export const leagueTournamentFieldsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/fields`);
export const leagueTournamentMatchRoute = (tournamentId, matchId) => league(`/tournaments/${tournamentId}/matches/${matchId}`);
export const leagueTournamentMatchIncidencesRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/incidences`);
export const leagueTournamentMatchIncidenceRoute = (tournamentId, matchId, incidenceId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/incidences/${incidenceId}`);
export const leagueTournamentMatchCheckInsRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/check-ins`);
export const leagueTournamentMatchCheckInRoute = (tournamentId, matchId, playerId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/players/${playerId}/check-in`);
export const leagueTournamentMatchPlayerRoute = (tournamentId, matchId, playerId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/players/${playerId}`);
export const leagueTournamentMatchGuestCheckInRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/guest-players`);
export const leagueTournamentMatchesCsvRoute = (tournamentId) => league(`/tournaments/${tournamentId}/matches/csv`);
export const leagueTournamentMatchPdfRoute = (tournamentId, matchId) => league(`/tournaments/${tournamentId}/matches/${matchId}/pdf`);
export const leagueTournamentMatchScannedPlanillaRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/scanned-planilla`);
export const leagueTournamentMatchPdfUrl = (tournamentId, matchId, { blank = false } = {}) => {
  // The match sheet is rendered in the tournament's zone by the server; the browser zone is not sent.
  const blankQuery = blank ? "?blank=1" : "";
  return `${baseUrl}${leagueTournamentMatchPdfRoute(tournamentId, matchId)}${blankQuery}`;
};
export const leagueTournamentGenerateFixturesRoute = (tournamentId) =>
  league(`/tournaments/${tournamentId}/generate-fixtures`);
export const leagueTournamentKnockoutRoute = (tournamentId) => league(`/tournaments/${tournamentId}/knockout`);
export const leagueTournamentKnockoutGenerateRoute = (tournamentId) =>
  league(`/tournaments/${tournamentId}/knockout/generate`);
export const leagueTournamentKnockoutSelectWinnerRoute = (tournamentId, pairId) =>
  league(`/tournaments/${tournamentId}/knockout-ties/${pairId}/select-winner`);
export const leagueTournamentMatchReopenRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/reopen`);
export const leagueTournamentMatchSelectWinnerRoute = (tournamentId, matchId) =>
  league(`/tournaments/${tournamentId}/matches/${matchId}/select-winner`);
export const leagueTournamentCloseRoute = (tournamentId) => league(`/tournaments/${tournamentId}/close`);
export const leagueTournamentReopenRoute = (tournamentId) => league(`/tournaments/${tournamentId}/reopen`);
export const leagueTournamentIncidencesRoute = (tournamentId) => league(`/tournaments/${tournamentId}/incidences`);
export const leagueTournamentSanctionsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/sanctions`);
export const leagueTournamentSanctionRoute = (tournamentId, sanctionId) =>
  league(`/tournaments/${tournamentId}/sanctions/${sanctionId}`);
export const leagueTournamentStandingsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/standings`);
export const leagueTournamentStandingsGoalersRoute = (tournamentId) => league(`/tournaments/${tournamentId}/standings/goalers`);
export const leagueTournamentStandingsSuspendedRoute = (tournamentId) => league(`/tournaments/${tournamentId}/standings/suspended`);
export const leagueTournamentStandingsRowColorsRoute = (tournamentId) => league(`/tournaments/${tournamentId}/standings-row-colors`);
export const leagueTournamentStandingsRowColorRoute = (tournamentId, rowColorId) =>
  league(`/tournaments/${tournamentId}/standings-row-colors/${rowColorId}`);
